module.exports = __webpack_public_path__ + "static/media/brand-icon-white.28784e2d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/brand-icon-white.svg
 ** module id = 317
 ** module chunks = 0
 **/